export default {
  fs: {
    dirs: {
      DocumentDir: '',
    },
  },
};
